import moment from 'moment';
import lv from 'moment/locale/lv';
import ru from 'moment/locale/ru';
import en from 'moment/locale/en-gb';

export const dateFormat = 'Do MMMM, YYYY';
export const dateFormatShort = 'DD.MM.YYYY';

const momentDate = (timestamp, lang, short) => {
  if (timestamp) {
    switch (lang) {
      case 'en':
        moment.updateLocale('en-gb', en);
        break;
      case 'ru':
        moment.updateLocale('ru', ru);
        break;
      default:
        moment.updateLocale('lv', lv);
    }

    const format = short ? dateFormatShort : dateFormat;
    const result = moment(timestamp * 1000).format(format);

    return result;
  }
  return '';
}

export default momentDate;



// WEBPACK FOOTER //
// ./src/utils/momentDate.js